<template>
  <div><IacBrowser /></div>
</template>


<script setup>
import IacBrowser from "@/components/iac/IacBrowser.vue";

import { useAppStore } from "@/store/app-store";
const appStore = useAppStore();
appStore.drawerExpanded = true;
</script>
